import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { getCSSFromStyleObject } from '@lexical/selection';
import { $createRangeSelection, $getRoot, $getSelection, $isRangeSelection, $setSelection } from 'lexical';
import { useEffect } from 'react';
import * as Models from 'models';
import { $verifyStyleForFont, $applyBrandStyleForFont, getStyleObjectForBrandStyle } from './brandStyle';

type Props = {
  brandStyle: Models.BrandStyleMap | undefined;
  brandStyleChanged: boolean | undefined;
  colors: Models.BrandColorsList;
  fonts: Models.BrandFontsList;
};

export function FontBrandStylePlugin(props: Props): null {
  const { brandStyle, colors, fonts, brandStyleChanged } = props;
  const [editor] = useLexicalComposerContext();

  useEffect(
    () => editor.registerEditableListener(() => {
      editor.update(() => {
        if ($isRangeSelection($getSelection()) && $getRoot().getAllTextNodes().length > 0) {
          return;
        }
        const brandStyleObject = getStyleObjectForBrandStyle(brandStyle, colors, fonts);
        const selection = $createRangeSelection();
        selection.setStyle(getCSSFromStyleObject(brandStyleObject));
        $setSelection(selection);
      });
    }),
    [editor, brandStyle, fonts, colors],
  );

  useEffect(
    () => {
      editor.update(() => {
        if (
          brandStyleChanged &&
          $getRoot().getAllTextNodes().length > 0
        ) {
          return;
        }

        $applyBrandStyleForFont(brandStyle, colors, fonts);
      });
    },
    // colors and fonts are intentionally skipped from the deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editor, brandStyle, brandStyleChanged],
  );

  useEffect(
    () => {
      editor.update(() => $verifyStyleForFont(colors, fonts));
    },
    [editor, colors, fonts],
  );

  return null;
}
